import { render, staticRenderFns } from "./infoEntreprise.vue?vue&type=template&id=52931dc6&scoped=true"
import script from "./infoEntreprise.vue?vue&type=script&lang=js"
export * from "./infoEntreprise.vue?vue&type=script&lang=js"
import style0 from "./infoEntreprise.vue?vue&type=style&index=0&id=52931dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52931dc6",
  null
  
)

export default component.exports